<lib-unauthenticated-layout [backgroundImageUrl]="backgroundImageUrl" [title]="title">
  <div title>
    <h2 class="text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
      {{ title || ('auth.login.title' | translate) }}
    </h2>
    <p class="mt-2 text-center text-sm text-gray-500 dark:text-gray-400">
      Accede con tus credenciales para continuar
    </p>
  </div>

  <div content>
    <form
      (ngSubmit)="onSubmit()"
      [formGroup]="form"
      class="mx-auto flex w-full max-w-sm flex-col space-y-5"
    >
      <!-- Email / RUC -->
      <div class="flex flex-col gap-1">
        <p-float-label variant="on">
          <label class="text-slate-700 dark:text-slate-200" for="email">
            {{ (loginType === 'ruc' ? 'auth.login.ruc' : 'auth.login.email') | translate }}
          </label>
          <input
            [type]="loginType === 'ruc' ? 'text' : 'email'"
            class="w-full text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-400"
            data-cy="email-input"
            formControlName="email"
            id="email"
            pInputText
          />
        </p-float-label>

        <small
          [style.visibility]="
            form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)
              ? 'visible'
              : 'hidden'
          "
          class="text-red-500 text-xs min-h-[1rem]"
          data-cy="email-error"
        >
          {{ getEmailError() }}
        </small>
      </div>

      <!-- Password -->
      <div class="flex flex-col gap-1">
        <p-float-label variant="on">
          <p-password
            [feedback]="false"
            formControlName="password"
            id="password"
            inputStyleClass="w-full text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-400"
            styleClass="w-full"
            toggleMask="true"
            data-cy="password-input"
          ></p-password>
          <label class="text-slate-700 dark:text-slate-200" for="password">
            {{ 'auth.login.password' | translate }}
          </label>
        </p-float-label>

        <small
          [style.visibility]="
            form.get('password')?.invalid &&
            (form.get('password')?.dirty || form.get('password')?.touched)
              ? 'visible'
              : 'hidden'
          "
          class="text-red-500 text-xs min-h-[1rem]"
          data-cy="password-error"
        >
          {{ getPasswordError() }}
        </small>
      </div>
      <div class="my-3 flex items-center justify-between">
        @if (!hideI18n) {
          <lib-i18n [variant]="variant || 'toggle'" />
        }
        <!-- Register link -->
        @if (!hideForgotPassword) {
          <div class="flex items-center justify-end">
            <div class="text-sm/6">
              <a
                [routerLink]="['/reset-password']"
                class="text-sm font-medium text-primary-600 transition-colors hover:text-primary-500 hover:underline dark:text-primary-400 dark:hover:text-primary-300"
                data-cy="forgot-password-link"
              >
                {{ 'auth.login.forgotPassword' | translate }}
              </a>
            </div>
          </div>
        }
      </div>

      <!-- Submit button -->
      <p-button
        [disabled]="form.invalid"
        [loading]="loading$ | async"
        label="{{ 'auth.login.submit' | translate }}"
        styleClass="w-full"
        type="submit"
        data-cy="login-button"
      />

      @if (!hideAzureLogin) {
        <p-button (onClick)="onAzureLogin()" [outlined]="true" styleClass="w-full" type="button">
          <div class="flex items-center justify-center gap-2">
            <img
              alt="Azure"
              class="h-5 w-5 object-contain"
              ngSrc="assets/images/Azure-Logo-PNG-Photo.png"
            />
            <span class="font-semibold">Ingresar con Azure</span>
          </div>
        </p-button>
      }

      @if (!hideRegister) {
        <div class="flex items-center justify-center !mt-4">
          <div class="text-sm/6">
            <a
              [routerLink]="['/register']"
              class="font-medium text-primary-600 transition-colors hover:text-primary-500 hover:underline dark:text-primary-400 dark:hover:text-primary-300"
            >
              {{ 'auth.login.notHaveAccount' | translate }}
            </a>
          </div>
        </div>
      }
      <ng-content select="[login-extra]"></ng-content>
    </form>
  </div>
</lib-unauthenticated-layout>
